// extracted by mini-css-extract-plugin
module.exports = {"checkBoxDiv":"inline-select-styles_checkBoxDiv__2dNNr","square":"inline-select-styles_square__1fL4Y","innerCheckbox":"inline-select-styles_innerCheckbox__1Gus7"};